<template>
  <section class="travel-quote-info">
    <h2>Policy Detail</h2>
    <travel-quote-info :formData="formData"></travel-quote-info>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'

export default {
  name: 'quote-refer-info',
  components: {TravelQuoteInfo},
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>

</style>